import { PersonHttpHelper, NO_DATA_MESSAGE } from "@usas/ui-web/utils/HttpHelper";

const postOfficialEvaluationData = (meetEvaluationId, officialEvaluationArray, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const meetEvaluationIdForUrl = meetEvaluationId ? encodeURIComponent(meetEvaluationId) : 'NaN';
    const url = `/OfficialEvaluation/meetEvaluation/${meetEvaluationIdForUrl}`;
    PersonHttpHelper(url, 'POST', officialEvaluationArray)
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoaded: true,
            isSaving: false,
            isSaved: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default postOfficialEvaluationData;